import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IIsSemibasementFloorTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const IsSemibasementFloorTagItem = ({ onDeleteClick, withNewTag }: IIsSemibasementFloorTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Полуподвал
    </TagComponent>
  );
};
